import { useMutation } from "@tanstack/react-query";

import useAccessRequestsApi from "./use-access-requests-api";

export default function usePassMfaForAccessRequests() {
  const api = useAccessRequestsApi();

  const {
    mutate: passMfaRequest,
    mutateAsync: passMfaRequestAsync,
    ...rest
  } = useMutation(async () => {
    const res = await api.passMfaForAccessRequests();
    return res;
  });

  return {
    passMfaRequest,
    passMfaRequestAsync,
    ...rest,
  };
}
